import React, { FC } from 'react'

import { AddCompanyManagerDropdown } from 'components/AddCompanyManagerDropdown'
import { AddProjectCoordinatorDropdown } from 'components/AddProjectCoordinatorDropdown'
import { Company, Project } from 'types'
// import { ErrorsDisplay } from 'components/ErrorsDisplay'
// import { NoticesDisplay } from 'components/NoticesDisplay'
import { styles } from './styles'
import { UserList } from 'components/UserList'
import { defaultTemplateId } from 'utils/constants'

export const CompanyDisplay: FC<{ company: Company; projects?: Project[] }> = ({
  company,
  projects = [],
}) => {
  return (
    <>
      {/* <ErrorsDisplay /> */}
      {/* <NoticesDisplay /> */}
      <h1 style={styles.companyManagerHeader}>{company.name}</h1>

      <h2 style={styles.companyManagersHeader}>Company Managers:</h2>
      <UserList users={company.companyManagers} />
      <AddCompanyManagerDropdown
        companyId={company.id}
        excludedCompanyManagers={company.companyManagers}
        templateDocumentId={defaultTemplateId}
      />

      <h2 style={styles.projectsHeader}>Projects:</h2>
      {projects.map(({ id, name, projectCoordinators }) => {
        return (
          <div key={`project-${id}`}>
            <header style={styles.projectHeader}>Title: {name}</header>
            <header style={styles.projectCoordinatorHeader}>
              Project Coordinators
            </header>
            <UserList users={projectCoordinators} key={`userlist-${id}`}/>
            <AddProjectCoordinatorDropdown
              excludedProjectCoordinators={projectCoordinators}
              projectId={id}
              templateDocumentId={defaultTemplateId}
            />
          </div>
        )
      })}
    </>
  )
}